export default __webpack_public_path__ + "static/media/mapFlag.a83d3a4f.svg";